var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "div",
        { attrs: { id: "job-detail" } },
        [
          _c(
            "b-breadcrumb",
            [
              _c("b-breadcrumb-item", { attrs: { text: "Jobs", to: "/jobs" } }),
              _vm._v(" "),
              _c("b-breadcrumb-item", {
                attrs: {
                  text: "" + _vm.job.labRegistrationReference,
                  active: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { "header-tag": "header", "header-class": "no-border" } },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "h2",
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "clipboard" }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.job.labRegistrationReference) +
                        "\n      "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.job && _vm.job.priority.toLowerCase().trim() == "urgent"
                  ? _c(
                      "span",
                      { staticClass: "urgent-flag" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "flag", "fixed-width": "" }
                        }),
                        _vm._v("Urgent\n      ")
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "job-status d-flex align-items-center" },
                [
                  _vm.job
                    ? _c(
                        "div",
                        {
                          staticClass: "badge badge-lg",
                          class:
                            "badge-" +
                            _vm.job.status
                              .toLowerCase()
                              .trim()
                              .replace(/ /g, "-")
                        },
                        [_vm._v(_vm._s(_vm.job.status))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [_vm._v("Priority")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.job.priority))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [_vm._v("Received")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(_vm.job.receivedDate, "D MMM YYYY")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [_vm._v("Due")]),
                    _vm._v(" "),
                    _vm.job.dueDate
                      ? _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(_vm.job.dueDate, "D MMM YYYY")
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.job.dueDate
                      ? _c("span", { staticClass: "value" }, [_vm._v("-")])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "label" }, [_vm._v("Finalised")]),
                    _vm._v(" "),
                    _vm.job.finalisedDateTime
                      ? _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("moment")(
                                _vm.job.finalisedDateTime,
                                "D MMM YYYY h:mmA"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.job.finalisedDateTime
                      ? _c("span", { staticClass: "value" }, [_vm._v("-")])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-border-right" }, [
                    _c("dl", [
                      _c("dt", [_vm._v("Client")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.job.client.name))]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Invoice Client")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.job.invoiceTo.name))]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Contact")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.job.client.firstName) +
                            " " +
                            _vm._s(_vm.job.client.lastName)
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "col-border-right" }, [
                    _c("dl", [
                      _c("dt", [_vm._v("Client Reference")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.job.clientRegistrationReference || "-")
                        )
                      ]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Purchase Order")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.job.clientOrderNumber || "-"))
                      ]),
                      _vm._v(" "),
                      _c("dt", [_vm._v("Sampling Site")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.job.samplingSite || "-"))])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("dl", [
                      _c("dt", [_vm._v("Samples")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.job.numberOfSamples))])
                    ])
                  ])
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-tabs",
            { staticClass: "mt-4" },
            [
              _c(
                "b-tab",
                { attrs: { active: "" } },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "vials" }
                      }),
                      _vm._v("Samples\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("SamplesTable", {
                    staticClass: "mt-4",
                    attrs: { "job-id": _vm.getJobId }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "chart-pie" }
                      }),
                      _vm._v("Results\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ResultsTable", {
                    staticClass: "mt-4",
                    attrs: { "job-id": _vm.getJobId }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.documents.length > 0
                ? _c(
                    "b-tab",
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "icon",
                            attrs: { icon: "file-alt" }
                          }),
                          _vm._v("Documents\n      ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.documents, function(document) {
                        return _c("DocumentCard", {
                          key: document.id,
                          attrs: { document: document, "job-id": _vm.jobId }
                        })
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-251c2f6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251c2f6e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobDetail.vue
// module id = H1yM
// module chunks = 1